import { Cancel, Check } from "@mui/icons-material";
import { Button, CircularProgress } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import DataContext from "../../../../../../../../context/DataContext";
import axios from "../../../../../../../api/axios";
import ModalShell from "../../../../../../../global/ModalShell";
import { HistoryTooltip } from "../../../../../../../modules/ClientDetail/Case/DynamicForm/components/HistoryTooltip";
import { LOST_OVERALL_STATUSES } from "../../../../../../../modules/ClientDetail/Case/utils/constants";
import HNSColors from "../../../../../../../ui library/HNSColors";

import LostStatus from "./components/LostStatus";

export default function LostButton({ caseObj }) {
  const { userRoles, trigger } = useContext(DataContext);
  const [open, setOpen] = useState(false);
  const [responseSuccess, setResponseSuccess] = useState(null);
  const [responseBreakdown, setResponseBreakdown] = useState("");
  const [loading, setLoading] = useState(false);
  const [lostDetails, setLostDetails] = useState("");
  const params = useParams();

  useEffect(() => {
    if (!caseObj || !caseObj.lost) {
      setLostDetails("");
      return;
    } else {
      axios.get(`/api/case/${caseObj.pk}/lost/`, {}).then((response) => {
        setLostDetails(response.data);
      });
    }
  }, [caseObj, setLostDetails, params, trigger]);

  return (
    <div className="w-full">
      <div className="flex items-center">
        <Button
          sx={{
            background: HNSColors.secondary[500],
            "&:hover": {
              background: HNSColors.secondary[600],
            },
          }}
          className="h-[40px] w-full min-w-[240px] rounded-full py-[4px] text-sm normal-case transition"
          variant="contained"
          onClick={() => setOpen(true)}
          disabled={
            Boolean(caseObj?.lost) ||
            LOST_OVERALL_STATUSES.includes(caseObj?.overall_status) ||
            !userRoles.permissions.includes("casemanager.add_loststatushistory")
              ? true
              : false
          }
        >
          Report Case Lost
        </Button>
        {loading ? (
          <CircularProgress color="secondary" />
        ) : responseSuccess === false ? (
          <Cancel className="text-red-600" />
        ) : (
          ""
        )}
        {lostDetails && lostDetails.created_by ? (
          <div className="ml-2">
            <HistoryTooltip
              historyData={{
                timestamp: lostDetails?.created_at,
                user: lostDetails.created_by?.name,
              }}
            />
          </div>
        ) : null}
      </div>
      {responseSuccess === false && responseBreakdown ? (
        <p className="text-[12px] text-red-600">{responseBreakdown}</p>
      ) : (
        ""
      )}
      {responseSuccess ? (
        <p className="text-[12px]">
          {responseBreakdown} <Check className="text-green-600" />
        </p>
      ) : (
        ""
      )}
      <ModalShell open={open} setOpen={setOpen} color={"#1976d2"} title={"Report Case Lost"}>
        <LostStatus
          caseDetail={caseObj}
          setOpenCustomDialog={setOpen}
          setResponseBreakdown={setResponseBreakdown}
          setResponseSuccess={setResponseSuccess}
          setLoading={setLoading}
        />
      </ModalShell>
    </div>
  );
}
